import React from 'react';
import HeadTitle from '../../../../components/HeadTitle';
import { Rule } from '../../../../models/Product';
import { getServiceOptionsTitle } from '../../../../utils/catalogRules';

type HeadPageProps = {
  productRules?: Rule[];
  handleGoBack: () => void;
};

const HeadPage: React.FC<HeadPageProps> = ({ productRules, handleGoBack }) => {
  const [title, setTitle] = React.useState('Escolha o tipo de atendimento');

  React.useEffect(() => {
    if (productRules) {
      const titleOfRule = getServiceOptionsTitle(productRules);
      if (titleOfRule) setTitle(titleOfRule);
    }
  }, []);
  return <HeadTitle title={title} goBack={handleGoBack} />;
};

export default HeadPage;
